import React, {useState} from "react";
import {Link} from "react-router-dom";

function FaqQuestionRow({faqElement}) {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={"faq2-row" + (expanded ? " faq2-row--expanded" : "")}>
            <button type="button" className="faq2-row-question" onClick={() => setExpanded(prev => !prev)}>
                <span>{faqElement.Question}</span>
                <span className={"faq2-row-toggle" + (expanded ? " faq2-row-toggle--open" : "")}>›</span>
            </button>
            {expanded && (
                <div className="faq2-row-answer">
                    <div dangerouslySetInnerHTML={{__html: faqElement.Answer}}/>
                    <p className="faq2-row-cta">
                        Chcesz wiedzieć więcej? <Link to="/kontakt">Skontaktuj się z nami</Link>
                    </p>
                </div>
            )}
        </div>
    );
}

function FaqCategorySection({section}) {

    return (
        <div className="faq2-category" id={section.id}>
            {section.faqElements.length > 0 && (
                <>
                    <p className="faq2-category-label">{section.title}</p>
                    <div className="faq2-questions">
                        {section.faqElements.map(faqElement => (
                            <FaqQuestionRow faqElement={faqElement} key={faqElement.ID}/>
                        ))}
                    </div>
                </>
            )}

            {section.children.map(child => (
                <FaqCategorySection key={child.id} section={child}/>
            ))}
        </div>
    );
}

export default FaqCategorySection;
